import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env;

const SideBar: React.FC = () => {
  const location = useLocation();
  const isResumePage = location.pathname.includes('/resume');

  return (
    <section id="sidebar">
      <section id="intro">
        <Link to="/" className="logo">
          <img
            src={`${PUBLIC_URL}/images/me.png`}
            alt="Alex Brinker - Senior Architect"
          />
        </Link>
        <header>
          <h2>Alex Brinker</h2>
          <p>
            <a href="mailto:alex@alexbrinker.com">alex@alexbrinker.com</a>
          </p>
        </header>
      </section>
      <section className="blurb">
        <h2>About</h2>
        <p>
          Hi, I&apos;m Alex. I&apos;m a Senior Architect at Slalom Build with
          deep expertise in quality engineering, .NET development, test
          automation, and API testing. Passionate about leveraging AI in
          software development and testing, I lead teams in building robust,
          scalable solutions. Outside of work, I enjoy skiing Midwest slopes and
          Colorado mountains, traveling with family, and exploring investment
          opportunities.
        </p>
        <ul className="actions">
          <li>
            {!isResumePage ? (
              <Link to="/resume" className="button">
                Learn More
              </Link>
            ) : (
              <Link to="/about" className="button">
                About Me
              </Link>
            )}
          </li>
        </ul>
      </section>

      <section id="footer">
        <ContactIcons />
        <p className="copyright">
          &copy; Alex D. Brinker | <Link to="/">www.alexbrinker.com</Link>.
        </p>
      </section>
    </section>
  );
};

export default SideBar;
